import React from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import logo from "../../assets/images/logo/logo.png";
import "../../assets/css/callback/callback.css";
const CallbackMessage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

   const articleId = location.state?.id || searchParams.get("id") || null;

   console.log("articleId:", articleId);
   

  const goToAnnonce = () => {
    if (!articleId) return navigate("/");
    return navigate(`/article/details/${articleId}`);
  };
  return (
    <div className="container">
      <div className="callback_header">
        <img src={logo} alt="logo deal.mg" className="callback_logo"/>
        <i
          className="bi bi-x-circle"
          role="button"
          onClick={() => navigate("/")}
        ></i>
      </div>
      <div className="callback_content">
        <i class="bi bi-check-circle-fill"></i>
        <h1>Message envoyé</h1>
        <span onClick={goToAnnonce} role="button">Revenir à l’annonce</span>
      </div>
    </div>
  );
};

export default CallbackMessage;
